export default {"src":"/_next/static/media/imageFallback.9555bf4e.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};